import React from 'react';
import type { Closing, JRCAppTabProps, JRCAppTabsProps, Open } from './template.type';
import { JRCIcon } from '../JRCIcon/JRCIcon';
import { AppTab, AppTabTooltip, AppTabCounter, AppTabContextContainer, AppTabEllipsisLabel } from './template.styles';

export function JRCAppTab({ label, active, icon, onClick, href, target, open, closing, count }: JRCAppTabProps) {
    return (
        <AppTab
            open={open}
            active={active}
            onClick={onClick}
            href={href}
            target={target}
            as={(href && 'a') || undefined}
            aria-current={(href && active && 'page') || undefined}>
            <AppTabTooltip condition={!open && !closing} tooltip={{ description: label, position: 'right' }}>
                <AppTabContextContainer open={open} closing={closing}>
                    <JRCIcon name={`icon-${icon}`} size={22} color="inherit" isMargin={false} />
                    {(open || closing) && <AppTabEllipsisLabel>{label}</AppTabEllipsisLabel>}
                </AppTabContextContainer>
                {count && open ? <AppTabCounter>{count}</AppTabCounter> : <></>}
            </AppTabTooltip>
        </AppTab>
    );
}

export function JRCAppTabs({ tabs, activeTab, ...props }: JRCAppTabsProps & Open & Closing) {
    return (
        <>
            {tabs.map(({ onClick, href, target, key, count, ...tab }) => {
                if (href) {
                    return (
                        <JRCAppTab
                            {...tab}
                            {...props}
                            active={key === activeTab}
                            key={key}
                            href={href}
                            target={target}
                            count={count}
                        />
                    );
                } else if (onClick) {
                    return (
                        <JRCAppTab
                            {...tab}
                            {...props}
                            active={key === activeTab}
                            key={key}
                            onClick={() => onClick(key)}
                            count={count}
                        />
                    );
                }
                return;
            })}
        </>
    );
}
